import React from 'react';
import { FiAlertTriangle, FiClock } from 'react-icons/fi';

const MaintenanceAlert = ({ data }) => {
  if (!data || !data.is_enabled) return null;
  
  const endTime = data.ends_at ? new Date(data.ends_at).toLocaleString('en-US', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  }) : null;
  
  return (
    <div className="bg-amber-100 border-r-4 border-amber-500 p-3 fixed top-16 left-0 right-0 z-40 shadow-md dark:bg-amber-900 dark:border-amber-600">
      <div className="container mx-auto">
        <div className="flex items-center justify-center">
          <div className="flex-1">
            <div className="flex items-center justify-center">
              <div className="flex-1 text-center">
                <p className="text-sm font-medium text-amber-800 dark:text-amber-200 flex items-center justify-center">
                  <FiAlertTriangle className="h-6 w-6 text-amber-500 dark:text-amber-400 ml-2" aria-hidden="true" />
                  <span>
                    <span className="font-bold">تنبيه للمسؤول:</span> الموقع حالياً في وضع الصيانة ولا يمكن للمستخدمين العاديين الوصول إليه. سيتم إيقاف وضع الصيانة تلقائياً عند انتهاء الوقت المحدد.
                    {endTime && (
                      <span className="mr-3 inline-flex items-center">
                        <FiClock className="inline-block ml-1" /> 
                        موعد انتهاء الصيانة: {endTime}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceAlert;
